import { PasswordLoginForm } from '../components/PasswordLoginForm';
import { Layout } from '../components/Layout';
import { useEffect } from 'react';
import Cookies from 'js-cookie';

export const PasswordLogin = () => {
  useEffect(() => {
    Cookies.remove('authentication_level_password');
    Cookies.remove('authentication_level_google_auth');
    Cookies.remove('authentication_level_email');
    Cookies.remove('authentication_level_sms');
    localStorage.clear();
  }, []);

  return (
    <Layout title="Sign in to your account">
      <PasswordLoginForm />
    </Layout>
  );
};
